/**
 * Labstep
 *
 * @module services/postFilter/constants/values
 * @desc PostFilter constant values - separated to avoid circular dependencies
 */

export const PostFilterComparisonHumanReadable = {
  eq: 'equals',
  neq: 'does not equal',
  lte: 'less than or equal to',
  lt: 'less than',
  gte: 'greater than or equal to',
  gt: 'greater than',
  null: 'is empty',
  not_null: 'is not empty',
  contains: 'includes',
  not_contains: 'excludes',
  exists: 'is not empty',
  not_exists: 'is empty',
} as const;

export const PostFilterComparisonHumanReadableChronologic = {
  eq: 'equals',
  neq: 'does not equal',
  lte: 'before or equal to',
  lt: 'before',
  gte: 'after or equal to',
  gt: 'after',
  null: 'is empty',
  not_null: 'is not empty',
  contains: 'includes',
  not_contains: 'excludes',
  exists: 'is not empty',
  not_exists: 'is empty',
} as const;

export const PostFilterComparisonHumanReadableShort = {
  eq: 'is',
  neq: 'is not',
  lte: '≤',
  lt: '<',
  gte: '≥',
  gt: '>',
  null: 'is empty',
  not_null: 'is not empty',
  contains: 'includes',
  not_contains: 'excludes',
} as const;

export const PostFilterOperator = {
  and: 'and',
  or: 'or',
} as const;

export const PostFilterComparison = {
  eq: 'eq',
  neq: 'neq',
  lte: 'lte',
  lt: 'lt',
  gte: 'gte',
  gt: 'gt',
  null: 'null',
  not_null: 'not_null',
  contains: 'contains',
  not_contains: 'not_contains',
  exists: 'exists',
  not_exists: 'not_exists',
} as const;
